import React, { useState, useEffect } from 'react';

import { createStdRequest, apiFetch } from '../utils/utils';

import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import KSelect from '../components/KSelect';
import CrmTextField from '../components/CrmTextField';

const makePageStyles = makeStyles((theme) => ({
  root: {
    marginTop: '30px',
  },
  pageTitle: {
    fontSize: '140%',
    fontWeight: 'bold',
    marginLeft: '40px',
    marginBottom: '12px',
  },
}));

const ConfigureCallRailPage = ({ firmId }) => {
  const configuredFirms = []; // just for the compiler ('fix')

  const myStyles = makePageStyles();

  return (
    <div className={myStyles.root}>
      <RegisterPanel firmId={firmId} />
      {false && <AddManagerPanel configuredFirms={configuredFirms} />}
    </div>
  );
};

const stdPanelRoot = {
  border: '1px solid black',
  marginBottom: '16px',
  marginLeft: '40px',
  width: '720px',
  padding: '12px',
};

const makeRegisterPanelStyles = makeStyles((theme) => ({
  root: stdPanelRoot,
  panelTitle: {
    fontSize: '125%',
    fontWeight: 'bold',
  },
  apiKeyDiv: {
    textAlign: 'left',
    marginTop: '8px',
  },
  phoneDiv: {
    textAlign: 'left',
    marginTop: '8px',
  },
  buttonDiv: {
    textAlign: 'center',
  },
  config4CrButton: {
    marginTop: '12px',
  },
  alertDiv: {
    margin: '10px',
    marginTop: '24px',
    padding: '10px',
    border: '2px dashed red',
  },
  alertHeraldSpan: {
    fontWeight: 900,
    color: 'red',
  },
  clearAlertButtonDiv: {
    marginTop: '14px',
    textAlign: 'center',
  },
}));

let handleMultipleAccounts_ext = () => {};
let handleMultipleCompanies_ext = () => {};
let setAndShowResults_ext = () => {};
let firmCallRailInfos_ext = [];
let setAlert_ext = () => {};
let clearAlert_ext = () => [];

const RegisterPanel = ({ firmId }) => {
  // const [idOfFirmToConfigure4CallRail, setIdOfFirmToConfigure4CallRail] = useState(firmId);
  const [resultData, setResultData] = useState({});
  const [firmName, setFirmName] = useState('');
  const [firmCallRailInfos, setFirmCallRailInfos] = useState([]);
  const [multipleAccounts, setMultipleAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [shouldShowMultipleAccountModal, setShouldShowMultipleAccountModal] = useState(false);
  const [multipleCompanies, setMultipleCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [shouldShowMultipleCompanyModal, setShouldShowMultipleCompanyModal] = useState(false);
  const [shouldShowResultsData, setShouldShowResultsData] = useState(false);
  // const [goal, setGoal] = useState('addNewConfig');
  const [shouldShowAlertDiv, setShouldShowAlertDiv] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const initialGoal = ''; // can't decide between 'addNewConfig' and 'modifyExistingCongig'

  useEffect(() => {
    const uri = `/api/firm/${firmId}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const name = json.name;
      setFirmName(name);
    };
    apiFetch(null, request, actionOnGoodResponse);
  }, []);

  useEffect(() => {
    const uri = `/api/superAdmin/firmCallRailInfo/${firmId}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      setFirmCallRailInfos(json);
      firmCallRailInfos_ext = json;
    };
    apiFetch(null, request, actionOnGoodResponse);
  }, []);

  const setApiKey = (infoId, newKey) => {
    const prevInfo = firmCallRailInfos.find((info) => info.firmCallRailInfoId === infoId);
    const modifiedInfo = { ...prevInfo, apiKey: newKey };
    const prunedInfos = firmCallRailInfos.filter((info) => info.firmCallRailInfoId !== infoId);
    const newArray = [modifiedInfo, ...prunedInfos];
    setFirmCallRailInfos(newArray);
  };

  const setSignatureSecretToken = (infoId, newToken) => {
    const prevInfo = firmCallRailInfos.find((info) => info.firmCallRailInfoId === infoId);
    const modifiedInfo = { ...prevInfo, webhookSignatureSecretToken: newToken };
    const prunedInfos = firmCallRailInfos.filter((info) => info.firmCallRailInfoId !== infoId);
    const newArray = [modifiedInfo, ...prunedInfos];
    setFirmCallRailInfos(newArray);
  };

  const setPhoneForAccount = (infoId, newPhone) => {
    const prevInfo = firmCallRailInfos.find((info) => info.firmCallRailInfoId === infoId);
    const modifiedInfo = { ...prevInfo, firstTrackingNumber: newPhone };
    const prunedInfos = firmCallRailInfos.filter((info) => info.firmCallRailInfoId !== infoId);
    const newArray = [modifiedInfo, ...prunedInfos];
    setFirmCallRailInfos(newArray);
  };

  const setAndShowResults = (resultData) => {
    setResultData(resultData);
    const shouldShow = Object.keys(resultData).length > 0;
    setShouldShowResultsData(shouldShow);
  };
  setAndShowResults_ext = setAndShowResults;

  const handleMultipleAccounts = (accounts) => {
    setMultipleAccounts(accounts);
    setSelectedAccountId('');
    setShouldShowMultipleAccountModal(true);
  };
  handleMultipleAccounts_ext = handleMultipleAccounts;

  const setToAlertWithMessage = (msg) => {
    setAlertMessage(msg);
    const show = !!msg;
    setShouldShowAlertDiv(show);
  };
  setAlert_ext = setToAlertWithMessage;

  const clearAlert = () => {
    setAlertMessage('');
    setShouldShowAlertDiv(false);
  };
  clearAlert_ext = clearAlert;

  const handleOkMultipleAccountModal = () => {
    setShouldShowMultipleAccountModal(false);
    if (selectedAccountId) {
      // const info = firmCallRailInfos.find(info => info.firmCallRailInfoId === infoId);
      // const info = firmCallRailInfos.find(info => info.firmCallRailInfoId === 0);
      const protoInfo = firmCallRailInfos[0];
      const info = { ...protoInfo, accountId: selectedAccountId, companyResourceId: '' };
      validateInputsAndCallConfigureApi(
        info,
        // info.firmId,
        // info.apiKey,
        // selectedAccountId,
        // '', // empty companyId
        // info.webhookSignatureSecretToken,
        // info.firstTrackingNumber,
        initialGoal
      );
    }
  };

  const handleCancelMultipleAccountModal = () => {
    setSelectedAccountId('');
    setShouldShowMultipleAccountModal(false);
  };

  const handleMultipleCompanies = (companies) => {
    setMultipleCompanies(companies);
    setSelectedCompanyId('');
    setShouldShowMultipleCompanyModal(true);
  };
  handleMultipleCompanies_ext = handleMultipleCompanies;

  const handleCloseMultipleCompanyModal = () => {
    setShouldShowMultipleCompanyModal(false);
    if (selectedCompanyId) {
      // const info = firmCallRailInfos.find(info => info.firmCallRailInfoId === infoId);
      // const info = firmCallRailInfos.find(info => info.firmCallRailInfoId === 0);
      const protoInfo = firmCallRailInfos[0];
      const info = { ...protoInfo, accountId: selectedAccountId, companyResourceId: selectedCompanyId };
      validateInputsAndCallConfigureApi(
        info,
        // info.firmId,
        // info.apiKey,
        // selectedAccountId,
        // selectedCompanyId,
        // info.webhookSignatureSecretToken,
        // info.firstTrackingNumber,
        initialGoal
      );
    }
  };

  const handleCancelMultipleCompanyModal = () => {
    setSelectedCompanyId('');
    setShouldShowMultipleCompanyModal(false);
  };

  const myStyles = makeRegisterPanelStyles();

  const nExistingConfigs = firmCallRailInfos.length;

  if (nExistingConfigs === 0) {
    const emptyConfig = {
      apiKey: '',
      accountId: '',
      companyId: 0,
      companyResourceId: '',
      firmCallRailInfoId: 0,
      firmId: firmId,
      firstTrackingNumber: '',
      webhookSignatureSecretToken: '',
    };
    const configsArray = [emptyConfig];
    setFirmCallRailInfos(configsArray);
  }

  const initial = nExistingConfigs == 1 && firmCallRailInfos[0].accountId === '';

  return (
    <div className={myStyles.root}>
      <Dialog open={shouldShowMultipleAccountModal} onClose={handleCancelMultipleAccountModal}>
        <DialogTitle>Choose a CallRail Account</DialogTitle>
        <DialogContent>
          <DialogContentText>The provided API Key is linked to {multipleAccounts.length} accounts.</DialogContentText>
          <FormControl variant="standard">
            <FormLabel id="demo-radio-buttons-group-label">Please choose one (or Cancel)</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={selectedAccountId}
              onChange={(event) => setSelectedAccountId(event.target.value)}
              name="radio-buttons-group"
            >
              {multipleAccounts.map((acct) => (
                <FormControlLabel key={acct.id} value={acct.id} control={<Radio />} label={acct.name} />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOkMultipleAccountModal}>Ok</Button>
          <Button onClick={handleCancelMultipleAccountModal}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={shouldShowMultipleCompanyModal} onClose={handleCloseMultipleCompanyModal}>
        <DialogTitle>Choose a CallRail-Associated Company</DialogTitle>
        <DialogContent>
          <DialogContentText>The provided API Key is linked to {multipleCompanies.length} companies.</DialogContentText>
          <FormControl variant="standard">
            <FormLabel id="demo-radio-buttons-group-label">Please choose one (or Cancel)</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={selectedCompanyId}
              onChange={(event) => setSelectedCompanyId(event.target.value)}
              name="radio-buttons-group"
            >
              {multipleCompanies.map((co) => (
                <FormControlLabel key={co.id} value={co.id} control={<Radio />} label={co.name} />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMultipleCompanyModal}>Ok</Button>
          <Button onClick={handleCancelMultipleCompanyModal}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <div className={myStyles.panelTitle}>
        Register {!initial && '(or modify) '}'{firmName}' as one of our in-CallRail Companies
      </div>
      <Grid container spacing={1}>
        <Grid item xs={11}>
          <div>
            {nExistingConfigs !== 0 && firmCallRailInfos[0].firmCallRailInfoId !== 0 ? (
              <ModifyOrAddConfigPanel
                firmName={firmName}
                existingInfos={firmCallRailInfos}
                setApiKey={setApiKey}
                setSignatureSecretToken={setSignatureSecretToken}
                setPhoneForAccount={setPhoneForAccount}
                shouldShowResultsData={shouldShowResultsData}
                resultData={resultData}
              />
            ) : (
              firmId !== 0 && (
                <InfoDisplayPanel
                  info={firmCallRailInfos[0]}
                  accountId={''}
                  companyId={''}
                  setApiKey={setApiKey}
                  setSignatureSecretToken={setSignatureSecretToken}
                  setPhoneForAccount={setPhoneForAccount}
                  showResults={shouldShowResultsData}
                  resultData={resultData}
                  goal={initialGoal}
                />
              )
            )}
          </div>
        </Grid>
      </Grid>

      {shouldShowAlertDiv && (
        <div className={myStyles.alertDiv}>
          <span className={myStyles.alertHeraldSpan}>ALERT:</span>&nbsp;
          {alertMessage}
          <div className={myStyles.clearAlertButtonDiv}>
            <Button variant="contained" onClick={clearAlert_ext}>
              Ok
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

const InfoDisplayPanel = ({
  info,
  accountId,
  companyId,
  setApiKey,
  setSignatureSecretToken,
  setPhoneForAccount,
  showResults,
  resultData,
  goal,
}) => {
  info = { ...info, accountId, companyResourceId: companyId };

  const myStyles = makeRegisterPanelStyles();

  return (
    <Grid container spacing={1}>
      <Grid item xs={7}>
        <div className={myStyles.apiKeyDiv}>
          <CrmTextField
            required
            fullWidth
            label="API Key"
            value={info.apiKey}
            onChange={(event) => setApiKey(info.firmCallRailInfoId, event.target.value)}
          />
        </div>
        <div className={myStyles.apiKeyDiv}>
          <CrmTextField
            fullWidth
            label="WebhookSignatureSecretToken (Optional)"
            value={info.webhookSignatureSecretToken}
            onChange={(event) => setSignatureSecretToken(info.firmCallRailInfoId, event.target.value)}
          />
        </div>
        <div className={myStyles.phoneDiv}>
          <CrmTextField
            fullWidth
            label="Sales Phone Line (optional)"
            value={info.firstTrackingNumber}
            onChange={(event) => setPhoneForAccount(info.firmCallRailInfoId, event.target.value)}
          />
        </div>
        <div className={myStyles.buttonDiv}>
          <Button
            className={myStyles.config4CrButton}
            variant="contained"
            color="primary"
            onClick={() =>
              validateInputsAndCallConfigureApi(
                info,
                // info.firmId,
                // info.apiKey,
                // accountId,
                // companyId,
                // info.webhookSignatureSecretToken,
                // info.firstTrackingNumber,
                goal
              )
            }
          >
            Configure for CallRail
          </Button>
        </div>
      </Grid>
      {showResults && (
        <Grid item xs={5}>
          <CRDataDisplay data={resultData} />
        </Grid>
      )}
    </Grid>
  );
};

const MultiModificationPanel = ({
  infos,
  setApiKey,
  setSignatureSecretToken,
  setPhoneForAccount,
  showResults,
  resultData,
  goal,
}) => {
  const [companies, setCompanies] = useState([]);
  const [chosenCompanyId, setChosenCompanyId] = useState('');
  const [accountId, setAccountId] = useState('');

  useEffect(() => {
    const apiKey = infos[0].apiKey;
    const uri = `/api/superAdmin/callRailCompaniesForApiKey/${apiKey}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (allCompaniesInAccount) => {
      const knownCompanyIds = infos.map((info) => info.companyResourceId);
      const matchingCompanies = allCompaniesInAccount.filter((co) => knownCompanyIds.indexOf(co.id) >= 0);
      setCompanies(matchingCompanies);
    };
    apiFetch(null, request, actionOnGoodResponse);
  }, []);

  let chosenInfo = {};

  const setChosenCompanyAndIds = (companyId) => {
    setChosenCompanyId(companyId);
    setAccountId(getAccountIdForCompanyId(companyId));
    chosenInfo = getInfoWithCompanyId(companyId);
  };

  const getAccountIdForCompanyId = (companyId) => {
    const selectedInfo = infos.find((info) => info.companyResourceId === companyId);
    return selectedInfo.accountId;
  };

  const getInfoWithCompanyId = (companyId) => {
    return infos.find((info) => info.companyResourceId === companyId);
  };

  // Try updating chosen company from possibly updated infos
  chosenInfo = getInfoWithCompanyId(chosenCompanyId);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={5}>
          Select existing Configuration
        </Grid>
        <Grid item xs={7}>
          <FormControl variant="standard" fullWidth>
            <InputLabel id="company-select-label">Company</InputLabel>
            <Select
              variant="standard"
              labelId="company-select-label"
              value={chosenCompanyId}
              label="Company"
              onChange={(event) => setChosenCompanyAndIds(event.target.value)}
            >
              {companies.map((co) => (
                <MenuItem key={co.id} value={co.id}>
                  {co.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {chosenCompanyId && (
          <Grid item xs={12}>
            <InfoDisplayPanel
              info={chosenInfo}
              accountId={accountId}
              companyId={chosenCompanyId}
              setApiKey={setApiKey}
              setSignatureSecretToken={setSignatureSecretToken}
              setPhoneForAccount={setPhoneForAccount}
              showResults={showResults}
              resultData={resultData}
              goal={goal}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

const ModifyOrAddConfigPanel = ({
  firmName,
  existingInfos,
  setApiKey,
  setSignatureSecretToken,
  setPhoneForAccount,
  shouldShowResultsData,
  resultData,
}) => {
  const [buttonChoice, setButtonChoice] = useState('modify');
  const nConfigs = existingInfos.length;
  const plural = nConfigs > 1;
  const info = existingInfos[0];
  const goal = buttonChoice === 'modify' ? 'modifyExistingConfig' : 'addNewConfig';

  let accountId = buttonChoice === 'modify' ? info.accountId : '';
  let companyId = buttonChoice === 'modify' ? info.companyResourceId : '';

  const handleButtonChange = (newValue) => {
    setButtonChoice(newValue);
    if (newValue === 'add') {
      accountId = '';
      companyId = '';
    } else if (newValue === 'modify' && nConfigs == 1) {
      accountId = info.accountId;
      companyId = info.companyResourceId;
    }
  };

  const herald = plural
    ? `There are currently ${nConfigs} CallRail Configurations for ${firmName}`
    : `There is currently one CallRail Configuration for ${firmName}`;

  return (
    <div>
      <div>{herald}</div>
      <FormControl variant="standard">
        <FormLabel id="demo-radio-buttons-group-label">Do you want to</FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={buttonChoice}
          onChange={(event) => handleButtonChange(event.target.value)}
          name="radio-buttons-group"
        >
          <FormControlLabel value="modify" control={<Radio />} label={`modify ${plural ? 'a' : 'the'} current one`} />
          <FormControlLabel value="add" control={<Radio />} label="add a new one" />
        </RadioGroup>
      </FormControl>
      {buttonChoice === 'add' && (
        <div>
          <div>You can use this API Key or submit another one.</div>
          <InfoDisplayPanel
            info={info}
            accountId={accountId}
            companyId={companyId}
            setApiKey={setApiKey}
            setSignatureSecretToken={setSignatureSecretToken}
            setPhoneForAccount={setPhoneForAccount}
            showResults={shouldShowResultsData}
            resultData={resultData}
            goal={goal}
          />
        </div>
      )}
      {buttonChoice === 'modify' && nConfigs === 1 && (
        <InfoDisplayPanel
          info={info}
          accountId={accountId}
          companyId={companyId}
          setApiKey={() => {}}
          setSignatureSecretToken={setSignatureSecretToken}
          setPhoneForAccount={setPhoneForAccount}
          showResults={shouldShowResultsData}
          resultData={resultData}
          goal={goal}
        />
      )}
      {buttonChoice === 'modify' && nConfigs > 1 && (
        <MultiModificationPanel
          infos={existingInfos}
          setApiKey={() => {}}
          setSignatureSecretToken={setSignatureSecretToken}
          setPhoneForAccount={setPhoneForAccount}
          showResults={shouldShowResultsData}
          resultData={resultData}
          goal={goal}
        />
      )}
    </div>
  );
};

function validateInputsAndCallConfigureApi(info, goal) {
  const {
    firmId,
    apiKey,
    accountId,
    companyResourceId: companyId,
    webhookSignatureSecretToken: signatureSecretToken,
    firstTrackingNumber: phone,
  } = info;

  if (!firmId) {
    showAlert('You need to select an Account to configure');
    return;
  }

  if (!isApiKeyFormat(apiKey)) {
    showAlert('The API Key needs to look like "0123456789abcdef01234..."');
    return;
  }

  if (signatureSecretToken && !isSignatureSecretTokenFormat(signatureSecretToken)) {
    showAlert('The (optional) WebhookSignatureSecretToken needs to look like "0123456789abcdef01234..."');
    return;
  }

  if (phone && !isStdFormatPhoneNumber(phone)) {
    showAlert('The (optional) Phone number must be blank or in format: "+1dddddddddd"');
    return;
  }

  // clear the "Returned Info" area
  setAndShowResults_ext({});

  if (goal === 'addNewConfig') {
    if (haveExistingConfigWithAcctAndCo(accountId, companyId)) {
      const msg = `You said you wanted to add a new configuration, but we already have one for the specified CallRail Account and Company`;
      showAlert(msg);
      return;
    }
  } else if (goal === 'modifyExistingConfig') {
    if (!haveExistingConfigWithAcctAndCo(accountId, companyId)) {
      const msg = `You said you wanted to modify and existing configuration, but we have none for the specified CallRail Account and Company`;
      showAlert(msg);
      return;
    }
  }

  const uriBase = '/api/superAdmin/configureForCallRail';
  const uri = goal === 'modifyExistingConfig' ? `${uriBase}/${info.firmCallRailInfoId}` : uriBase;
  const apiStruct = {
    firmCallRailInfoId: info.firmCallRailInfoId,
    firmId: firmId,
    apiKey: apiKey,
    accountId: accountId,
    companyId: companyId,
    signatureSecretToken: signatureSecretToken,
    destinationNumber: phone,
  };
  const method = goal === 'modifyExistingConfig' ? 'PUT' : 'POST';
  const request = createStdRequest(uri, method, apiStruct);
  const actionOnGoodResponse = (returnObj) => {
    if (returnObj.success) {
      setAndShowResults_ext(returnObj);
    } else {
      if (returnObj.tooManyAccounts) {
        handleMultipleAccounts_ext(returnObj.accounts); // let user choose which, then query for companies
      } else if (returnObj.tooManyCompanies) {
        handleMultipleCompanies_ext(returnObj.companies); // let user choose which, then do a POST (I guess)
      } else {
        const message = returnObj.errorMessage;
        showAlert(message + ' You may need to set this account up by hand.');
      }
    }
  };
  apiFetch(null, request, actionOnGoodResponse);
}

const haveExistingConfigWithAcctAndCo = (accountId, companyId) => {
  const matches = firmCallRailInfos_ext.filter(
    (info) => info.accountId === accountId && info.companyResourceId === companyId
  );
  return matches.length > 0;
};

function isApiKeyFormat(possibleApiKey) {
  if (!possibleApiKey || possibleApiKey.length !== 32) {
    return false;
  }
  for (const c of possibleApiKey) {
    if ('0123456789ABCDEFabcdef'.indexOf(c) < 0) {
      return false;
    }
  }
  return true;
}

function isSignatureSecretTokenFormat(possibleSecretToken) {
  if (possibleSecretToken && possibleSecretToken.length !== 32) {
    return false;
  }
  for (const c of possibleSecretToken) {
    if ('0123456789ABCDEFabcdef'.indexOf(c) < 0) {
      return false;
    }
  }
  return true;
}

function isStdFormatPhoneNumber(numStr) {
  if (numStr.length !== 12 || numStr[0] !== '+') {
    return false;
  }
  for (let i = 1; i < 12; i++) {
    const ch = numStr[i];
    if (ch < '0' || ch > '9') {
      return false;
    }
  }
  return true;
}

const makeAddManagerPanelStyles = makeStyles((theme) => ({
  root: stdPanelRoot,
  panelTitle: {
    fontSize: '125%',
    fontWeight: 'bold',
  },
  buttonDiv: {
    marginTop: '8px',
    textAlign: 'center',
  },
}));

const AddManagerPanel = ({ configuredFirms }) => {
  const [chosenFirmId, setChosenFirmId] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const myStyles = makeAddManagerPanelStyles();

  const configuredFirmNames = configuredFirms.map((firm) => firm.name);
  const configuredFirmIds = configuredFirms.map((firm) => firm.firmId);

  return (
    <div className={myStyles.root}>
      <div className={myStyles.panelTitle}>Add Manager to existing Company (not yet functional)</div>
      <div>
        <KSelect
          fullWidth
          label="Account"
          liveOptions={configuredFirmNames}
          liveValues={configuredFirmIds}
          value={chosenFirmId}
          onChange={(event) => setChosenFirmId(event.target.value)}
        />
      </div>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextField
            variant="standard"
            label={'First Name'}
            fullWidth
            required
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="standard"
            label={'Last Name'}
            fullWidth
            required
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="standard"
            label={'Email'}
            fullWidth
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <div className={myStyles.buttonDiv}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => addManager(chosenFirmId, firstName, lastName, email)}
            >
              Add Manager
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

function addManager(firmId, firstName, lastName, email) {
  const validation = validateAddManagerForm(firmId, firstName, lastName, email);
  if (validation.valid) {
    showAlert(
      `If this were actually implemented, we would now add Manager ${firstName} ${lastName} for firm ${firmId}`
    );
    // see documentation at https://apidocs.callrail.com/#creating-a-user
  } else {
    showAlert(validation.errorMessage);
  }
}

function validateAddManagerForm(firmId, firstName, lastName, email) {
  if (firmId === 0) {
    return { valid: false, errorMessage: 'You need to select an Account' };
  }
  if (!firstName) {
    return { valid: false, errorMessage: 'You need to fill in the First Name field' };
  }
  if (!lastName) {
    return { valid: false, errorMessage: 'You need to fill in the Last Name field' };
  }
  if (!validateEmail(email)) {
    return { valid: false, errorMessage: 'You need to provide a plausible Email address' };
  }
  return { valid: true };
}

function validateEmail(email) {
  return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

const makeCrDataDisplayStyles = makeStyles((theme) => ({
  root: {
    marginTop: '12px',
    marginLeft: '8px',
    border: '1px solid black',
    padding: '6px',
    width: 'fit-content',
  },
  hiddenRoot: {
    visibility: 'hidden',
  },
  panelTitle: {
    fontSize: '110%',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  label: {
    fontWeight: 'bold',
  },
  value: {
    marginLeft: '6px',
    fontSize: '75%',
    fontFamily: 'Courier',
  },
  clearButtonDiv: {
    textAlign: 'center',
  },
}));

const CRDataDisplay = ({ data }) => {
  const myStyles = makeCrDataDisplayStyles();

  const { companyId, companyResourceId, signingKey, trackingNumber } = data;

  const shouldBeVisible = companyResourceId;

  const clearAndRefresh = () => {
    setAndShowResults_ext({});
    window.location.reload(false);
  };

  return (
    <div className={shouldBeVisible ? myStyles.root : myStyles.hiddenRoot}>
      <div className={myStyles.panelTitle}>Returned Info</div>
      <div className={myStyles.label}>Company ID</div>
      <div className={myStyles.value}>{companyId}</div>
      <div className={myStyles.label}>Company Resource ID</div>
      <div className={myStyles.value}>{companyResourceId}</div>
      <div className={myStyles.label}>WebHook Signing Key</div>
      <div className={myStyles.value}>{signingKey}</div>
      <div className={myStyles.label}>Tracking Number</div>
      <div className={myStyles.value}>{trackingNumber}</div>
      <div className={myStyles.clearButtonDiv}>
        <Button variant="contained" color="primary" onClick={clearAndRefresh}>
          Clear
        </Button>
      </div>
    </div>
  );
};

const showAlert = (msg) => {
  setAlert_ext(msg);
};

export default ConfigureCallRailPage;
